import RegistrationSuccessPage from './RegistrationSuccessPage';

export default RegistrationSuccessPage;
